import React, { useState, useEffect } from "react";
import API from "utils/API";
import Html from "utils/Html";

import EmployeeInfo from "./RightContentEmployeeInfo";
import PersonalData from "./RightContentPersonalData";
import UserGroups from "./RightContentUserGroups";
import DashboardAccess from "./RightContentDashboardAccess";
import Notification from "./RightContentNotification";
import { useInfo } from "context/InfoContext";
import { GetReportByGroup } from "components/infos/events";
import ModalError from "../Container/modal.error";

export default function RightContent({ userData }) {
  const { infos, filterData, storeFilterData, filters, handleEvents } =
    useInfo();
  const [isEmailValid, setIsEmailValid] = useState(true); // To track email validity
  // console.log(filters);
  // Function to check if email exists in the database
  const checkEmailExists = async (email) => {
    const mainFunc = async () =>
      await API.post("info/user/checkemail", {
        params: ({
          email: email,
        }),
      });
    mainFunc()
      .then((res) => {
        const decrypt = (res?.data);
        console.log("response=", decrypt);
        if (decrypt?.status === "success") {
          setIsEmailValid(false);
        } else {
          setIsEmailValid(true);
        }
      })
      .catch((err) => {
        //console.log(infos.tabActive, err);
        setIsEmailValid(true);
      });
  };

  // console.log("userData=", userData);
  useEffect(() => {
    const mainFunc = async () =>
      await API.post("info/filter", {
        params: ({
          country_name: userData?.user_countries_access?.names,
          country_code: userData?.user_countries_access?.codes,
          is_access_all_country: userData.user_sess.userCanAccessAllCountries,
          is_exo_group: userData.is_exo_group,
          type: infos.tabActive,
          staff_id: infos?.staff_id ?? 0,
        }),
      });
    mainFunc()
      .then((res) => {
        const decrypt = (res?.data);
        // console.log("info filter=", decrypt);
        if (decrypt?.status === "success" && decrypt?.data) {
          if (decrypt.data?.rep_data) {
            decrypt.data["rep_data_by_group"] = GetReportByGroup(
              decrypt.data.rep_data
            );
          }
          storeFilterData(decrypt);
        } else {
          storeFilterData({
            err: 1,
            err_msg: decrypt?.err_msg ?? "",
          });
        }
      })
      .catch((err) => {
        //console.log(infos.tabActive, err);
        storeFilterData({ err: 1, err_msg: `Failes : ${err}` });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infos?.tabActive, infos?.keyChange]);
  // console.log("filterData=", filterData);
  // console.log("userData=>", userData);
  // console.log("filters=>", filters);
  // console.log("infos=>", infos);
  if (filterData.err === 1) {
    return <div>1. Fetch request error: {filterData.err_msg}</div>;
  } else if (
    filterData.data === "" ||
    (filterData?.status !== "success" &&
      filterData?.status !== "error save user") ||
    infos.tabActive !== filterData.type ||
    (filters?.is_first_load === false && infos?.staff_id !== 0)
  ) {
    return (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  }

  let content = "";
  if (infos.tabActive === "personaldata") {
    content = <PersonalData userData={userData} handleEvents={handleEvents} />;
  } else if (infos.tabActive === "notification") {
    content = <Notification userData={userData} handleEvents={handleEvents} />;
  } else if (infos.tabActive === "usergroups") {
    content = <UserGroups userData={userData} handleEvents={handleEvents} />;
  } else if (infos.tabActive === "dashboardaccess") {
    content = (
      <DashboardAccess userData={userData} handleEvents={handleEvents} />
    );
  } else {
    content = <EmployeeInfo userData={userData} handleEvents={handleEvents} />;
  }

  let modalContent = "";
  if (filterData?.status === "error save user" && filterData?.message !== "") {
    const callbackEvent = {
      OnClose: function () {},
      OnComplete: function () {},
    };
    modalContent = (
      <ModalError
        header={"ERROR!"}
        content={filterData.message}
        callbackEvent={callbackEvent}
        addon={{ setTime: 60000 }}
      />
    );
  }

  return (
    <div id="right-content" className="col s10" style={{ paddingLeft: "20px" }}>
      {content}
      {modalContent}
    </div>
  );
}

